import React from 'react';

export interface ContactData {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  message: string; // optional free text, sent with the lead
}

interface Props {
  formData: ContactData;
  formErrors: { firstName: string; lastName: string; email: string; phone: string };
  setFormData: React.Dispatch<React.SetStateAction<ContactData>>;
  handleFormSubmit: (e: React.FormEvent) => void;
}

const ContactForm: React.FC<Props> = ({ formData, formErrors, setFormData, handleFormSubmit }) => {
  return (
    <>
      <div className="p-4 md:p-6 pb-0">
        <h2 className="text-2xl font-bold text-gray-900 mb-4">Contact details</h2>
      </div>

      <div className="overflow-y-auto px-4 md:px-6 max-h-[calc(100vh-520px)] lg:max-h-[calc(100vh-150px)]">
        <form onSubmit={handleFormSubmit} className="space-y-4 mb-6">
          <div>
            <label className="block text-xs font-medium text-gray-700 mb-2">YOUR FIRST NAME</label>
            <input
              type="text"
              placeholder="Fill in your first name"
              value={formData.firstName}
              onChange={(e) => setFormData({ ...formData, firstName: e.target.value })}
              className={`w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-black focus:border-transparent ${
                formErrors.firstName ? 'border-red-500' : 'border-gray-300'
              }`}
            />
            {formErrors.firstName && <p className="text-red-500 text-xs mt-1">{formErrors.firstName}</p>}
          </div>

          <div>
            <label className="block text-xs font-medium text-gray-700 mb-2">YOUR LAST NAME</label>
            <input
              type="text"
              placeholder="Fill in your last name"
              value={formData.lastName}
              onChange={(e) => setFormData({ ...formData, lastName: e.target.value })}
              className={`w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-black focus:border-transparent ${
                formErrors.lastName ? 'border-red-500' : 'border-gray-300'
              }`}
            />
            {formErrors.lastName && <p className="text-red-500 text-xs mt-1">{formErrors.lastName}</p>}
          </div>

          <div>
            <label className="block text-xs font-medium text-gray-700 mb-2">EMAIL</label>
            <input
              type="email"
              placeholder="Fill in your email"
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              className={`w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-black focus:border-transparent ${
                formErrors.email ? 'border-red-500' : 'border-gray-300'
              }`}
            />
            {formErrors.email && <p className="text-red-500 text-xs mt-1">{formErrors.email}</p>}
          </div>

          <div>
            <label className="block text-xs font-medium text-gray-700 mb-2">PHONE</label>
            <input
              type="tel"
              placeholder="Fill in your phone"
              value={formData.phone}
              onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
              className={`w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-black focus:border-transparent ${
                formErrors.phone ? 'border-red-500' : 'border-gray-300'
              }`}
            />
            {formErrors.phone && <p className="text-red-500 text-xs mt-1">{formErrors.phone}</p>}
          </div>

          <div>
            <label className="block text-xs font-medium text-gray-700 mb-2">MESSAGE</label>
            <textarea
              placeholder="Add your message"
              rows={4}
              value={formData.message}
              onChange={(e) => setFormData({ ...formData, message: e.target.value })}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent resize-none"
            />
          </div>

          <button
            type="submit"
            className="w-full py-3 bg-black text-white rounded-lg font-semibold hover:bg-gray-800 transition-colors flex items-center justify-center gap-2 cursor-pointer"
          >
            Submit
            <img
              src="https://cdn.prod.website-files.com/68472be536d16d9004a489e5/69c2f77e872fffc7542078c5_IcOutlineCheck.png"
              alt="Check"
              className="w-4 h-4"
              style={{ filter: 'invert(1)' }}
            />
          </button>
        </form>
      </div>
    </>
  );
};

export default ContactForm;
